import { IAplDocumentMeta } from '../models/aplDocument'

export const parseDocumentMeta = (jsonString: string): IAplDocumentMeta | null => {
  try {
    return JSON.parse(jsonString)
  } catch (e) {
    return null
  }
}
